import styled from 'styled-components';

import { Color } from 'style/types';

type Props = {
  color?: Color;
};

export const Romie20 = styled.h5<Props>`
  font-size: 20px;
  line-height: 140%;
  color: ${({ color }) => color || 'var(--c-white)'};
  font-family: Romie-Regular, serif;
  font-weight: 400;

  & b {
    font-weight: 400;
    color: var(--c-pink-600);
  }
`;

export const MarketingText32 = styled.p`
  font-size: 32px;
  line-height: 115%;
  color: ${({ color }) => color || 'var(--c-white)'};

  & b {
    font-weight: 400;
    font-style: italic;
    font-family: Romie-Italic, serif;
    color: var(--c-pink-600);
  }

  & a {
    font-weight: 400;
    font-style: italic;
    font-family: Romie-Italic, serif;
    color: var(--c-pink-1000);
  }
`;

export const MarketingText20 = styled.p`
  font-size: 20px;
  line-height: 140%;
  color: ${({ color }) => color || 'var(--c-white)'};

  & b {
    font-weight: 400;
    font-style: italic;
    font-family: Romie-Italic, serif;
    background-color: var(--c-pink-600);
  }

  & a {
    font-weight: 400;
    font-style: italic;
    font-family: Romie-Italic, serif;
    color: var(--c-pink-1000);
  }
`;
